import React from "react";
import AboutMD from "../components/About/AboutMD";

const About = () => {
  return <AboutMD />;
};

export default About;
